import * as React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import ORDER_STATUS from '../../../../constants/orderStatus';
import { logisticTasksPetrolResourceActions } from '../../../../../../../entities/logistic/logisticTasks/redux/logisticTasksPetrol.slice';
import setCustomTime from '../../../utils/setCustomTime';
import { useAppSelector } from '../../../../../../../app/store';
import reducerPath from '../../../../../../../app/reducerPath';

export default function TimeCell({ row, dispatch, type }) {
  const logisticTask = useAppSelector((state) => state[`${reducerPath.logisticTasksPetrolResource}/counter`]);

  const isAllocated = !!row.color;
  const value = type === 'loading' ? row.loading?.slice(0, 5) : row.unloading?.slice(0, 5);
  const statusColor = row?.statuses?.includes(ORDER_STATUS.IS_NOT_IN_TIME) ? 'red' : null;

  const handleChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const newData = JSON.parse(JSON.stringify(logisticTask));
    if (isAllocated) {
      newData.data.solution.routes = newData.data.solution.routes.map((route) => {
        const newRoute = JSON.parse(JSON.stringify(route));
        newRoute.orders = newRoute.orders.map((orderCurrent) => {
          const newOrder = JSON.parse(JSON.stringify(orderCurrent));
          if (orderCurrent?.orderSource?.requestId === row.id) {
            const newTime = setCustomTime(
              type === 'loading' ? orderCurrent.loadingTime : orderCurrent.deliveryTime,
              event.target.value,
            );
            if (newTime) {
              if (type === 'loading') newOrder.loadingTime = newTime;
              else newOrder.deliveryTime = newTime;
            }
          }
          return newOrder;
        });
        return newRoute;
      });
    } else {
      newData.data.solution.notClosedRequests = newData.data.solution.notClosedRequests.map((orderItem) => {
        const orderCurrent = JSON.parse(JSON.stringify(orderItem));
        if (orderCurrent?.requestId === row.id) {
          const newTime = setCustomTime(
            type === 'loading'
              ? orderCurrent.loadingTime || new Date().toISOString()
              : orderCurrent.deliveryTime || new Date().toISOString(),
            event.target.value,
          );
          if (newTime) {
            if (type === 'loading') orderCurrent.loadingTime = newTime;
            else orderCurrent.deliveryTime = newTime;
          }
        }
        return orderCurrent;
      });
    }
    dispatch(logisticTasksPetrolResourceActions.setData(newData));
  };

  return (
    <TextField
      inputProps={{ style: { color: statusColor } }}
      id="startWork"
      size="small"
      fullWidth
      defaultValue={value}
      variant="standard"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onChange={handleChange}
    />
  );
}
TimeCell.propTypes = {
  row: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['loading', 'unloading']).isRequired,
};
